import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  // *** ИСПРАВЛЕНО: добавлены правильные URL для соцсетей ***
  const socialLinks = [
    { id: 1, icon: 'fab fa-vk', href: 'https://vk.com/kprf_nefteyugansk', label: 'ВКонтакте' },
    { id: 2, icon: 'fab fa-odnoklassniki', href: 'https://ok.ru/profile/568134600283', label: 'Одноклассники' },
  ];

  // *** НОВЫЙ БЛОК: массив с данными для партнеров ***
  const partnerLinks = [
    { id: 1, name: 'Окружной сайт КПРФ', href: 'https://kprf-ugra.ru/' },
    { id: 2, name: 'Хостинг Timeweb', href: 'https://timeweb.com/ru/?i=138091' },
  ];

  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          {/* Левый блок с описанием */}
          <div className="footer-logo">
            <h3>КПРФ Нефтеюганск</h3>
            <p>Официальный сайт Нефтеюганского городского отделения Коммунистической партии Российской Федерации.</p>
            <p>За социальную справедливость, народовластие и социализм!</p>
          </div>

          {/* Блок с быстрыми ссылками */}
          <div className="footer-links">
            <h4>Быстрые ссылки</h4>
            <ul>
              <li><Link to="/">Главная</Link></li>
              <li><Link to="/gallery">Галерея</Link></li>
              <li><Link to="/documents">Документы</Link></li>
              <li><Link to="/events">Мероприятия</Link></li>
              <li><Link to="/howtojoin">Вступить в партию</Link></li>
              <li><Link to="/archived-news">Архив новостей</Link></li> {/* НОВОЕ */}
            </ul>
          </div>

          {/* Блок с социальными сетями */}
          <div className="footer-social">
            <h4>Мы в соцсетях</h4>
            <div className="social-icons">
              {socialLinks.map(social => (
                <a 
                  key={social.id} 
                  href={social.href} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label={social.label}
                >
                  <i className={social.icon}></i>
                </a>
              ))}
            </div>
            <p style={{ marginTop: '20px' }}>Подписывайтесь, чтобы быть в курсе нашей борьбы!</p>
          </div>

          {/* *** НОВЫЙ БЛОК: Наши партнеры *** */}
          <div className="footer-links">
            <h4>Наши партнеры</h4>
            <ul className="partner-links">
              {partnerLinks.map(partner => (
                <li key={partner.id}>
                  <a 
                    href={partner.href} 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    {partner.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="copyright">
          <p>&copy; {new Date().getFullYear()} Нефтеюганское городское отделение КПРФ. Все права защищены.</p>
          <p>Сайт создан на общественных началах активистами партии.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;